import React from "react";
import "./AddElement.css";
export const AddElement = props => {
  const { create } = props;
  return (
    <div
      className="add-element-btn"
      onClick={create}
      style={{ width: "100%", fontsize: "20px" }}
    >
      <i style={{ fontSize: "15px" }} className="fa fa-plus" />
    </div>
  );
};
